/**
 * Safely extract dashboard data from API responses
 * Handles various response formats from the backend
 */

export function extractStatsData(response: any) {
  if (!response) return {};
  
  // If response has a data property, use that
  if (response.data && typeof response.data === 'object') {
    return response.data;
  }
  
  // Otherwise use the response directly
  return response;
}

export function extractArrayData(response: any): any[] {
  if (!response) return [];
  
  // If it's already an array, return it
  if (Array.isArray(response)) {
    return response;
  }
  
  // If response has a data property that's an array, use that
  if (response.data && Array.isArray(response.data)) {
    return response.data;
  }
  
  // If response has a data property that has a data sub-property
  if (response.data?.data && Array.isArray(response.data.data)) {
    return response.data.data;
  }
  
  // If it's an object with items property
  if (response.items && Array.isArray(response.items)) {
    return response.items;
  }
  
  return [];
}

export function extractChartData(response: any): any[] {
  if (!response) return [];
  
  // If it's already an array of chart data, return it
  if (Array.isArray(response)) {
    return response;
  }
  
  // If response has monthly_revenue array
  if (Array.isArray(response.monthly_revenue)) {
    return response.monthly_revenue.map((item: any) => ({
      name: item.month || item.name,
      Revenue: item.revenue || 0,
      Cost: item.cost || 0,
      Profit: item.profit || 0,
    }));
  }
  
  // If response has data property
  if (response.data) {
    if (Array.isArray(response.data)) {
      return response.data;
    }
    if (Array.isArray(response.data.monthly_revenue)) {
      return response.data.monthly_revenue.map((item: any) => ({
        name: item.month || item.name,
        Revenue: item.revenue || 0,
        Cost: item.cost || 0,
        Profit: item.profit || 0,
      }));
    }
  }
  
  return [];
}

export function validateDashboardData(data: any) {
  return {
    stats: data.stats && typeof data.stats === 'object' ? data.stats : {},
    chartData: Array.isArray(data.chartData) ? data.chartData : [],
    events: Array.isArray(data.events) ? data.events : [],
    quotations: Array.isArray(data.quotations) ? data.quotations : [],
    enquiries: Array.isArray(data.enquiries) ? data.enquiries : [],
    tasks: Array.isArray(data.tasks) ? data.tasks : [],
    lastUpdated: data.lastUpdated instanceof Date ? data.lastUpdated : new Date(),
  };
}
